export const TABLE_BORDER_COLOR = '#2F736E1F';

export const TABLE_HEADER_RADIUS = '12px';

const APP_ACCESS_BORDER_COLOR = '#2F736E';

export const PASTED_APP_ACCESS_BG = '#2F736E08';

export const sectionHeaderCellSx = {
  border: `1px solid ${TABLE_BORDER_COLOR}`,
  minWidth: 'fit-content',
  p: '11px',
  textAlign: 'left',
};

export const sectionHeaderCellBorderlessSx = {
  ...sectionHeaderCellSx,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
};

export const tableHeaderCellSx = {
  backgroundColor: '#F0F0F1',
  borderBottom: `1px solid ${TABLE_BORDER_COLOR}`,
  minWidth: 'fit-content',
  p: '11px',
  textAlign: 'left',
  verticalAlign: 'middle',
};

export const sectionHeaderLabelSx = {
  fontSize: '12px',
  fontWeight: 700,
  color: '#162936',
};

export const tableScrollContainerSx = {
  width: '100%',
  overflowX: 'auto',
};

export const tableWrapperSx = {
  border: `1px solid ${TABLE_BORDER_COLOR}`,
  borderRadius: TABLE_HEADER_RADIUS,
  overflow: 'auto',
  maxWidth: 'fit-content',
};

export const tableSx = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'auto',
  '& tbody td:first-of-type': { borderLeft: 'none' },
  '& tbody td:last-of-type': { borderRight: 'none' },
  '& tbody tr:last-of-type td': { borderBottom: 'none' },
  '& thead th:not(:last-of-type)': {
    borderRight: `1px solid ${TABLE_BORDER_COLOR}`,
  },
};

export const cellSx = {
  border: `1px solid ${TABLE_BORDER_COLOR}`,
  p: 0,
  verticalAlign: 'middle',
};

export const cellContentSx = {
  display: 'flex',
  alignItems: 'center',
  minHeight: '24px',
};

export const submoduleLabelStyles = {
  fontSize: '14px',
  fontWeight: 500,
  color: '#1B1C17',
  whiteSpace: 'nowrap',
};

export const checkboxSx = {
  color: '#D8DBDD',
  '&.Mui-checked': { color: '#2F736E' },
  '&.Mui-disabled': { color: '#D8DBDD' },
};

export const submoduleCellSx = {
  ...cellSx,
  width: '45%',
  minWidth: '360px',
};

export const appAccessCellSx = {
  ...cellSx,
  p: 0,
  width: '30%',
  minWidth: '240px',
  height: '1px',
  lineHeight: 0,
};

export const appAccessSelectWrapperSx = {
  height: '100%',
  display: 'flex',
};

export const appAccessMenuPaperSx = {
  borderRadius: '8px',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
  mt: '4px',
};

export const appAccessMenuItemSx = {
  fontSize: '14px',
  fontWeight: 500,
  color: '#1B1C17',
  py: '10px',
  px: '12px',
  '&:hover': {
    backgroundColor: PASTED_APP_ACCESS_BG,
  },
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: PASTED_APP_ACCESS_BG,
    },
  },
};

export const appAccessPlaceholderStyles = {
  fontSize: '14px',
  fontWeight: 500,
  color: '#989CA2',
};

export const copyPasteCellSx = {
  ...cellSx,
  width: '25%',
  minWidth: '220px',
};

export const actionIconStyles = {
  color: '#51B8B0',
};

export const disabledActionIconStyles = {
  color: '#D8DBDD',
};

export const getAppAccessCellSx = (hasPastedAccess: boolean) => ({
  ...appAccessCellSx,
  backgroundColor: hasPastedAccess ? PASTED_APP_ACCESS_BG : 'transparent',
});

export const getAppAccessSelectWrapperSx = (hasPastedAccess: boolean) => ({
  ...appAccessSelectWrapperSx,
  backgroundColor: hasPastedAccess ? PASTED_APP_ACCESS_BG : 'transparent',
});

export const getAppAccessSelectSx = (hasPastedAccess: boolean) => ({
  flex: 1,
  alignSelf: 'stretch',
  width: '100%',
  height: '100%',
  m: 0,
  fontSize: '14px',
  fontWeight: 500,
  color: '#1B1C17',
  borderRadius: 0,
  backgroundColor: hasPastedAccess ? PASTED_APP_ACCESS_BG : 'transparent',
  '&.MuiInputBase-root': {
    height: '100%',
    backgroundColor: hasPastedAccess ? PASTED_APP_ACCESS_BG : 'transparent',
  },
  '&.MuiOutlinedInput-root': {
    height: '100%',
    minHeight: 'unset',
    borderRadius: 0,
    p: 0,
    backgroundColor: hasPastedAccess ? PASTED_APP_ACCESS_BG : 'transparent',
  },
  '& .MuiOutlinedInput-input': {
    height: '100%',
    p: '0 32px 0 12px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    fontSize: '14px',
    fontWeight: 500,
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: '100%',
    minHeight: 'unset',
    py: '0 !important',
    pl: '12px',
    pr: '32px',
    fontSize: '14px',
    fontWeight: 500,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${APP_ACCESS_BORDER_COLOR}`,
    borderRadius: '4px',
  },
  '& .MuiSelect-icon': {
    color: APP_ACCESS_BORDER_COLOR,
    right: '8px',
  },
});
